import PubSub from './pub-sub';
import {BREAKPOINT} from './breakpoint.constants';

const BreakpointDispatcher = {
  start,
  getState,
  breakpoint: BREAKPOINT.NAME
}

const BreakpointHandler = {
  mobile: {handleChange: handleMobileContext},
  tablet: {handleChange: handleTabletContext},
  desktop: {handleChange: handleDesktopContext}
};

var state = null;
var isStarted = false; 

function start() {
  if (isStarted) {
    return;
  }
  isStarted = true;

  setCurrentState();
  window.addEventListener('resize', handleResize);
};

function handleContext(context) {
  BreakpointHandler[context].handleChange();
}

function setCurrentState() {
  if (getViewportWidth() <= BREAKPOINT.WIDTH.MOBILE) {
    state = BREAKPOINT.NAME.MOBILE;
  } 
  else if (getViewportWidth() <= BREAKPOINT.WIDTH.TABLET)  {
    state = BREAKPOINT.NAME.TABLET;
  }
  else if (getViewportWidth() > BREAKPOINT.WIDTH.TABLET)  {
    state = BREAKPOINT.NAME.DESKTOP;
  }
}

function getViewportWidth() {
  return window.innerWidth;
}

function handleMobileContext() {
  if (getViewportWidth() > BREAKPOINT.WIDTH.MOBILE) {
    state = BREAKPOINT.NAME.TABLET;
    PubSub.publish('resize:tablet');
  }
};

function handleTabletContext() {
  let winSize = getViewportWidth();

  if (winSize > BREAKPOINT.WIDTH.TABLET) {
    state = BREAKPOINT.NAME.DESKTOP;
    PubSub.publish('resize:desktop');
  }
  else if (winSize <= BREAKPOINT.WIDTH.MOBILE) {
    state = BREAKPOINT.NAME.MOBILE;
    PubSub.publish('resize:mobile');
  }
};

function handleDesktopContext() {
  if (getViewportWidth() <= BREAKPOINT.WIDTH.TABLET) {
    state = BREAKPOINT.NAME.TABLET;
    PubSub.publish('resize:tablet');
  }
};

function handleResize() {
  handleContext(state);

  PubSub.publish('resize');
}

function getState() {
  return state;
};

export default BreakpointDispatcher;


// WEBPACK FOOTER //
// ./src/js/utils/breakpoint-dispatcher.js